// extracted by mini-css-extract-plugin
export default {"first-to-lower":"ow5V","firstToLower":"ow5V","first-to-upper":"H7lO","firstToUpper":"H7lO","uppercase":"lYrV","lowercase":"PMdr","capitalize":"QDGj"};